
























import Vue from 'vue';

export default Vue.extend({
  props: {
    value: String as () => 'my' | 'sg' | 'id',
  },

  methods: {
    handleChange(e: Event) {
      e.preventDefault();
      // @ts-ignore Event targe value will exist on radio button
      const val = e.target.value;
      this.$emit('change', val);
      this.$emit('input', val);
    },
  },
});
